import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import { AccountPanel } from "./AccountPanel";
import { NavRow } from "./NavRow";
import { TAIL_ITEMS } from "./navItems";
import { useT } from "../../shared/i18n";

/**
 * Phone tail and account: the burger opens this bottom sheet with Print,
 * Export and Trash, then the account section (spec §7). An overlay never
 * changes the route or the nav visibility.
 */
export function TailSheet({
  open,
  onClose,
  onNavigate,
}: {
  open: boolean;
  onClose: () => void;
  onNavigate: (path: string) => void;
}) {
  const t = useT();
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      data-testid="tail-sheet"
      slotProps={{
        paper: {
          // A named dialog, not an unlabelled presentation surface: the sheet
          // traps focus and its purpose must be announced (spec §10).
          role: "dialog",
          "aria-modal": true,
          "aria-label": t("menu"),
          sx: {
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
            pb: "env(safe-area-inset-bottom)",
          },
        },
      }}
    >
      <Box sx={{ pt: 1 }} role="presentation">
        {TAIL_ITEMS.map(({ key, path, href, labelKey, icon }) => (
          <NavRow
            key={key}
            icon={icon}
            label={t(labelKey)}
            orientation="horizontal"
            testId={`nav-tail-${key}`}
            href={href}
            onClick={() => {
              if (path) onNavigate(path);
              onClose();
            }}
          />
        ))}
        <Divider sx={{ my: 1 }} />
        <AccountPanel onNavigate={onClose} />
      </Box>
    </Drawer>
  );
}
